// app.service.ts (version avancée)
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { CoreStorageService } from '@/core/services/core-storage.service';
import { STORAGE_KEYS } from '@/core/constants/storage-keys';

@Injectable({
  providedIn: 'root',
})
export class loginService {
  private storageKey = STORAGE_KEYS.SHARED_USER;
  private userData: BehaviorSubject<boolean>;
  public userData$: Observable<boolean>;

  constructor(private coreStorage: CoreStorageService) {
    // Initialisation avec la valeur du LocalStorage
    const initialValue = this.getStoredValue();
    this.userData = new BehaviorSubject<boolean>(initialValue);

    // Abonnement pour sauvegarder automatiquement tout changement
    this.userData$ = this.userData.asObservable().pipe(distinctUntilChanged());

    this.userData$.subscribe((value) => {
      this.saveToLocalStorage(value);
    });
  }

  setUserData(data: boolean): void {
    this.userData.next(data);
  }

  getCurrentUserData(): boolean {
    return this.userData.getValue();
  }

  private saveToLocalStorage(data: boolean): void {
    this.coreStorage.setItem(this.storageKey, data);
  }

  private getStoredValue(): boolean {
    try {
      const storedValue = this.coreStorage.getItem<any>(this.storageKey);
      return storedValue ? Boolean(storedValue) : false;
    } catch (error) {
      console.error('Error reading from storage:', error);
      return false;
    }
  }

  clearUserData(): void {
    this.userData.next(false);
    this.coreStorage.removeItem(this.storageKey);
  }
}
